import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/Authenticate/StaffGoogleRefresh-Token', {
            withCredentials: true
        });

        // Handle 204 No Content response (no refresh token available)
        if (response.status === 204) {
            // Don't call setAuth here - auth should already be empty
            // Calling setAuth({}) would create a new object reference and trigger re-renders
            return null;
        }

        // The backend returns AccessToken (capital A), so we need to handle both cases
        const accessToken = response.data.AccessToken || response.data.accessToken;

        // setAuth({ user: response.data.username, role: response.data.role, accessToken: response.data.accessToken, components: response?.data?.components });
        setAuth({
            userId: response.data.userId,
            user: response.data.username,
            fullName: response.data.fullName,
            email: response.data.email,
            role: response.data.role,
            accessToken: accessToken,
            universityId: response.data.universityId,
            universityName: response.data.universityName,
            lastSuccessfulLoginDate: response.data.lastSuccessfulLoginDate,

        });
        return accessToken;
    }
    return refresh;
};

export default useRefreshToken;
